<template>
<div @click="$emit('closeMessage')">
    <modal size="medium">
        <div slot="header">
            <div class="row columns">
                Informations sur les équipes :
            </div>
            <div class="row columns small-font">
                <div class="row columns small-font">Pour qu'une équipe puisse être séléctionnée dans un rapport de match, elle doit : </div>
                <div class="row columns small-font">- appartenir au joueur connecté (sauf pour les admins)</div>
                <div class="row columns small-font">- avoir été publié (ne pas être en mode brouillon)</div>
                <div class="row columns small-font">- avoir fait les montées de niveau</div>
                <div class="row columns small-font">- avoir validé les achats </div>
                <div class="row columns small-font">- ne pas être dans un autre rapport de match en cours de saisie</div>
            </div>
        </div>
        <div v-if="teamList" class="roster" slot="body">
        <table v-if="teamList.length > 0" class="row column ranking">
            <thead>
                <tr class="">
                    <th width="10%"></th>
                    <th width="20%" class="team_name_header"></th>
                    <th width="20%" class="last_stat">en etat de jouer ?</th>
                    <th width="60%" >Raison</th>
                </tr>
            </thead>
            <tr  v-for="team in teamList"
                @click="teamClicked(ranking_line.team.id)">
                <td><img class="small-icon" :src="getRosterIcon(team.ref_roster)" alt="team"></td>
                <td>{{team.name}}</td>
                <td v-if="getStatus(team)" class="error">non</td>
                <td v-else class="valid">oui</td>
                <td>{{getStatus(team)}}</td>
            </tr>
        </table>
        <div v-else>
                vous n'avez pas d'équipe dans cette ligue, commencez par en créer une
        </div>
        </div>
        <div v-else slot="body">
            pas d'équipe dans cette ligue
        </div>
        <div slot="footer" class="panel-footer" >
            <div class="row columns">
                <button class="large-4 light-grey-button" @click="$emit('closeMessage')">aaaaah okokokok</button>
            </div>
            <br>
        </div>
    </modal>
</div>
</template>
<script>
import modal from './modal.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'

export default {
  name: 'teamStatusModal',
  components: {
    modal
  },
  props: {
    'league': null
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'clubList',
      'matchReportList',
      'currentUser'
    ]),
    teamList: function () {
      if (this.league) {
        if (this.currentUser.is_superuser === true) {
          return store.getters.teamListForLeague(this.league)
        } else {
          return store.getters.teamListForLeague(this.league).filter(team => {
            return team.user === this.currentUser.username
          })
        }
      }
      return null
    }
  },
  methods: {
    getRosterIcon (roster) {
      return '/static/imgs/team-icons/' + roster.replace(/\s+/, '') + '.png'
    },
    getStatus (team) {
      if (team.status === 0) {
        return 'l\'équipe n\'est pas publiée, allez sur la page de l\'équipe'
      }
      if (team.status === 2) {
        return 'Il reste des montées de niveaux a faire pour cette équipe'
      }
      if (team.status === 3) {
        return 'Les achats de l\'équipe ne sont pas terminés'
      }

      let startedReports = this.matchReportList.filter(mr => { return mr.status === 0 })
      let foundreport = startedReports.find(mr => { return mr.home_report.team.id === team.id || mr.visitor_report.team.id === team.id })
      if (foundreport) {
        return 'l\'équipe est dans le rapport de match n°' + foundreport.id + ' dont la saisie est en cours'
      }
      return null
    }
  },
  created () {
    store.dispatch('refreshTeamList')
    store.dispatch('getMatchReportList')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.small-font {
  font-size:0.8rem
}
.error {
  font-size:0.9rem;
  color: red;
}
.valid {
  font-size:0.9rem;
  color: green;
}

.modal-mask {
  position:fixed
}

.small-icon {
  width: 30px;
  height: 30px;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tr td{
    padding: 0.3rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}
</style>



// WEBPACK FOOTER //
// team-status-modal.vue?6da598fa